import Panel from './panel';

export default class LoadingPanel extends Panel {
  render() {
    const spinner = this.getTag('spinner');

    // spinner needs an extra inner wrapper div, due to transform() weirdness
    if (spinner) {
      const { element } = spinner;
      const inner = element.cloneNode();
      inner.style.transform = 'rotate(0deg)';
      inner.style.top = 0;
      inner.style.left = 0;
      element.style.border = '';
      element.style.background = '';
      inner.classList.add('inner');
      spinner.element.appendChild(inner);
    }
  }
}
